
import { ModelMatch } from 'apps/idl/src/modules/utils/models/decorators/model-match.decorator';
import { IIdlPrestationLine } from './iidl-prestation-line';
import { IPrestationLine } from '../../prestation/models/iprestation-line';
import { PrestationLine } from '../../prestation/models/prestation-line';

@ModelMatch((poData: IPrestationLine) => !!poData, PrestationLine)
export class IdlPrestationLine extends PrestationLine implements IIdlPrestationLine {

	//#region PROPERTIES

	/** @implements */
	public originalLineRef?: string;

	/** @implements */
	public ordonnanceId: string;

	/** @implements */
	public lettreCle?: string;

	/** @implements */
	public coefficient?: number;

	//#endregion

	//#region METHODS

	constructor(poData?: IIdlPrestationLine) {
		super(poData);
	}

	/** @override */
	public reset(): PrestationLine {
		this.originalLineRef = undefined;
		return super.reset();
	}

	//#endregion

}
